__turbopack_context__.v({
  "addButton": "MemberDetailHeader-module-scss-module__G69Y8G__addButton",
  "addPill": "MemberDetailHeader-module-scss-module__G69Y8G__addPill",
  "desktopOnly": "MemberDetailHeader-module-scss-module__G69Y8G__desktopOnly",
  "divider": "MemberDetailHeader-module-scss-module__G69Y8G__divider",
  "funds": "MemberDetailHeader-module-scss-module__G69Y8G__funds",
  "fundsLabel": "MemberDetailHeader-module-scss-module__G69Y8G__fundsLabel",
  "header": "MemberDetailHeader-module-scss-module__G69Y8G__header",
  "headerDetails": "MemberDetailHeader-module-scss-module__G69Y8G__headerDetails",
  "headerProfile": "MemberDetailHeader-module-scss-module__G69Y8G__headerProfile",
  "headerProfileImg": "MemberDetailHeader-module-scss-module__G69Y8G__headerProfileImg",
  "investorTag": "MemberDetailHeader-module-scss-module__G69Y8G__investorTag",
  "location": "MemberDetailHeader-module-scss-module__G69Y8G__location",
  "locationName": "MemberDetailHeader-module-scss-module__G69Y8G__locationName",
  "moreTeamsButton": "MemberDetailHeader-module-scss-module__G69Y8G__moreTeamsButton",
  "role": "MemberDetailHeader-module-scss-module__G69Y8G__role",
  "roleAndLocation": "MemberDetailHeader-module-scss-module__G69Y8G__roleAndLocation",
  "specificsHdr": "MemberDetailHeader-module-scss-module__G69Y8G__specificsHdr",
  "specificsName": "MemberDetailHeader-module-scss-module__G69Y8G__specificsName",
  "tagDivider": "MemberDetailHeader-module-scss-module__G69Y8G__tagDivider",
  "tags": "MemberDetailHeader-module-scss-module__G69Y8G__tags",
  "teamLink": "MemberDetailHeader-module-scss-module__G69Y8G__teamLink",
  "teamLinkEmpty": "MemberDetailHeader-module-scss-module__G69Y8G__teamLinkEmpty",
  "teams": "MemberDetailHeader-module-scss-module__G69Y8G__teams",
  "teamsName": "MemberDetailHeader-module-scss-module__G69Y8G__teamsName",
});
